module.exports = __webpack_public_path__ + "static/media/medidas.4d5a35d9.png";